<!-- 人才服务 -->
<template>
    <div class="talentService">
        <!-- 顶部背景 -->
        <div class="top-banner-box">
            <div class="top-banner-img" :style="{ backgroundImage: `url(${headerBgUrl})` }">
                <div class="top-banner-center">
                    <div class="wow animate__animated animate__zoomIn banner-btn" @click="onClickLookMore">
                        服务咨询
                    </div>
                </div>
            </div>
        </div>
        <!-- 直播公开课、职称评审服务 -->
        <liveOpenClass></liveOpenClass>
        <!-- 线下专题培训、继续教育课程 -->
        <trainingCourse v-show="showTrain"></trainingCourse>
        <!-- 线上精品课程 -->
        <onlineCourse v-show="showCourse"></onlineCourse>
    </div>
</template>
<script>
import {
    getDictionaryItem
} from "../../utils/interface";
import liveOpenClass from './liveOpenClass.vue'
import trainingCourse from './trainingCourse.vue'
import onlineCourse from './onlineCourse.vue'
export default {
    name: 'talentService',
    components: { liveOpenClass,trainingCourse,onlineCourse },
    props: {},
    data() {
        return {
            headerBgUrl: '',
            showTrain: false,
            showCourse: false
        };
    },
    created() {
        this.getOptionsData()
    },
    mounted() { 
        window.addEventListener("scroll", this.menu);
    },
    methods: {
        getOptionsData() {
            //顶部背景图
            getDictionaryItem({
                code: 'RCFW_BANNER'
            }).then((res) => {
                if (res != null && res.length > 0) {
                    this.headerBgUrl = res[0].value
                } else {
                    this.headerBgUrl = ''
                }
            });
        },
        onClickLookMore() {

        },
          // 页面滚动
          menu() {
            let scroll = document.documentElement.scrollTop || document.body.scrollTop;
            // console.log('scroll  ' + scroll)
            if (scroll > 180) {
                this.showTrain = true
            }
            if (scroll > 640) {
                this.showCourse = true
            }
        }
    }
};
</script>
<style scoped lang="less">
.talentService {
    position: relative;
    top: -80px;
    .top-banner-box {
        // background-color: #f7f8fb;

        .top-banner-img {
            height: 500px;
            width: 100%;
            overflow: hidden;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .top-banner-center {
                width: 1300px;
                height: 500px;
                position: relative;
            }

            .banner-btn {
                width: 130px;
                margin-left: 30px;
                // background-color: white;
                color: transparent;
                letter-spacing: 2px;
                text-align: center;
                padding: 12px 0;
                border-radius: 7px;
                cursor: pointer;
                user-select: none;
                position: absolute;
                bottom: 77px;
                transition: all .2s;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/talentServices/index.vue